export const ADS_ROUTE_NAME = 'settings_ads';
export const ADS_PROVIDER_ROUTE_NAME = 'settings_ads_provider';
export const ADS_WORKSPACE_ROUTE_NAME = 'ads_rastro';
